import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';
import Employee from 'main/stores/employees/Employee';

class TaxDocumentAssignment extends DomainObject {
  id;
  sendFederalTaxForm = false;
  sendProvincialTaxForm = false;
  employees = [];
  dueDate;

  _relations = {
    employees: [Employee],
    _dates: ['dueDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      sendFederalTaxForm: observable,
      sendProvincialTaxForm: observable,
      employees: observable,
      dueDate: observable
    });

    this.merge(other);
  }
}

export default TaxDocumentAssignment;
